import { render, staticRenderFns } from "./DeliveryOrderDetails.vue?vue&type=template&id=33034692&scoped=true&"
import script from "./DeliveryOrderDetails.vue?vue&type=script&lang=js&"
export * from "./DeliveryOrderDetails.vue?vue&type=script&lang=js&"
import style0 from "./DeliveryOrderDetails.vue?vue&type=style&index=0&id=33034692&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33034692",
  null
  
)

export default component.exports